import { createFileRoute, Outlet } from '@tanstack/react-router'

import { HiddenOnTrial } from '@/modules/account'

export const Route = createFileRoute('/_authenticated/documents')({
  component: DocumentsLayoutComponent,
})

function DocumentsLayoutComponent() {
  return (
    <HiddenOnTrial>
      <Outlet />
    </HiddenOnTrial>
  )
}
